import { Alert, Box, Button, Card, Chip, Grid, IconButton, InputAdornment, Modal, Snackbar, TextField, Typography } from '@mui/material'
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import { makeStyles } from '@mui/styles';
import React, { useEffect } from 'react'
import Promas from '../../icons/Promas.svg'
import { InputField } from '../../components/InputController';
import PTI from '../../icons/PromasToInosio.svg'
import { getExistingIntegrations, getNullifyApiKey, getCreateNewIntegration, getUpdatePromasApiKey, selectIntegrationState } from './sagas/pmIntegrationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { CreateSoftwareIntegrationDto, SoftwareIntegrationCredentialTypeEnum, UpdateIntegrationApiKeyDto } from '@inosio/payments-sdk';
import PromasProcess from '../../icons/updatedintegration.svg'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import DeleteIcon from '../../icons/delete_Icon.svg';
import CancelIcon from '@mui/icons-material/Cancel';
import { getUpdateOnboardingApplication } from '../onboarding/sagas/pmonboardingSlice';
import { useHistory } from 'react-router';
import MaintenanceBackIcon from '../../icons/MaintenanceBackIcon.svg';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: '#FFFFFF',
    borderRadius: '24px',
    boxShadow: 24,
    display: 'flex',
    flexDirection: 'column',
};

export default function PromasIntegration(props: any) {
    const dispatch = useDispatch();
    const [snackBarOpen, setSnackBarOpen] = React.useState(false);
    const [formOpen, setFormOpen] = React.useState(false);
    const [openConfirmation, setOpenConfirmation] = React.useState(false)
    const [selectedPortfolioName, setSelectedPortfolioName] = React.useState('');
    const [selectedSoftwareCredentialId, setSelectedSoftwareCredentialId] = React.useState('');
    const [formPortfolioName, setFormPortfolioName] = React.useState('');
    const [showPassword, setShowPassword] = React.useState(false);
    const handleClickShowPassword = () => setShowPassword(true);
    const handleFormOpen = () => setFormOpen(true);
    const handleConfirmationOpen = () => setOpenConfirmation(true)
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackBarOpen(false);
    };
    const IntegrationState = useSelector(selectIntegrationState);
    const useStyles = makeStyles({
        gridContainer: {
            background: "#FFFFFF",
            borderRadius: "24px",
        },
        btnStyle: {
            background: "rgba(57, 162, 219, 1) !important",
            borderRadius: "24px !important",
            color: "#fff !important",
            marginRight: "12px !important",
            padding: "6px 17px !important",
            marginTop: "15px !important",
        },
        btnStyleDisabled: {
            background: "rgba(211, 211, 211, 1) !important",
            borderRadius: "24px !important",
            color: "#fff !important",
            marginRight: "12px !important",
            padding: "6px 17px !important",
            marginTop: "15px !important",
        },
        btnStyleLight: {
            background: "rgba(162,219,250, 1) !important",
            borderRadius: "24px !important",
            color: "#fff !important",
            marginRight: "12px !important",
            padding: "6px 17px !important",
            marginTop: "15px !important",
        },
        inputStyle: {
            borderRadius: "24px !important",
            height: "49px  !important",
            marginBottom: "16px !important",
            boxShadow: "0px 0px 40px 0px rgba(0, 0, 0, 0.1) !important",
            outline: "none !important",


        },
    });
    const classes = useStyles();
    const onCreate = () => {
        dispatch(
            {
                type: getCreateNewIntegration.type,
                payload: {
                    Name: formPortfolioName,
                    IntegrationType: SoftwareIntegrationCredentialTypeEnum.Promas
                } as CreateSoftwareIntegrationDto
            })
    }

    const handleUpdateApiKey = () => {
        dispatch(
            {
                type: getUpdatePromasApiKey.type,
                payload: {
                    SoftwareCredentialId: selectedSoftwareCredentialId
                } as UpdateIntegrationApiKeyDto
            })
    }

    useEffect(() => {
        if (IntegrationState.apiKey) {
            setFormOpen(false)
            setOpenConfirmation(false)
        }
    }, [IntegrationState.apiKey])

    useEffect(() => {
        dispatch({
            type: getExistingIntegrations.type,
            payload: { integrationType: SoftwareIntegrationCredentialTypeEnum.Promas}
        })

        //we update onboarding state after successful integration
        dispatch({
            type: getUpdateOnboardingApplication.type,
            payload: {
                company_uuid: props?.pmDetails?.Company?.Uuid,
                data: {},
            },
        });
    }, [IntegrationState.isSuccess])

    const history = useHistory();
    return (
        <Grid item xs={12} sx={{ mt: 3.5 }}>
            {IntegrationState.error && IntegrationState.error.length > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}><Alert severity="error">{IntegrationState.error}</Alert></Box>
            )}
            <Card sx={{ p: 2, display: "flex", flexDirection: "column" }} className={classes.gridContainer}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <img src={MaintenanceBackIcon} style={{ height: '20px', width: '20px', marginRight: '30px', cursor: 'pointer' }} alt="back" onClick={()=>{history.push('/pmui/integrations');}} />
                            <Typography sx={{ color: "#14142B", fontSize: "24px" }}>
                                Promas
                            </Typography>
                            <Link href='https://support.inosio.com/article/how-to-configure-the-promas-integration' sx={{ pl: 2, pt: 1.2, fontSize: '12px' }}>Need help to add this integration?</Link>
                        </Grid>
                        <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {IntegrationState.existingPortfolios.length > 0 ?
                                IntegrationState.existingPortfolios.map((exispf, index) => {
                                    return (
                                        <Chip
                                            key={`Portfolio${index}`}
                                            clickable={true}
                                            label={exispf.Name}
                                            deleteIcon={<IconButton><img src={DeleteIcon} alt='delete icon'/></IconButton>}
                                            onClick={() => {
                                                setSelectedPortfolioName(exispf.Name)
                                                setSelectedSoftwareCredentialId(exispf.SoftwareCredentialId)
                                                dispatch({
                                                    type: getNullifyApiKey.type
                                                })
                                            }}
                                            onDelete={() => { }}
                                            sx={{
                                                bgcolor: exispf.SoftwareCredentialId === selectedSoftwareCredentialId ? "rgba(162,219,250, 1)" : "#fff",
                                                color: "#39A2DB",
                                                height: '42px',
                                                fontSize: '14px',
                                                lineHeight: '22px',
                                                border: '2px solid #39A2DB',
                                                borderRadius: '24px',
                                                marginLeft: '5px'
                                            }} />
                                    )
                                })
                                : null}
                        </Grid>
                        <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button 
                                variant="contained" 
                                sx={{
                                        width: "90%",
                                        height: '42px', 
                                        borderRadius: "24px", 
                                        backgroundColor: "#39A2DB", 
                                        textTransform: 'none', 
                                        boxShadow: 'none'
                                    }}
                                onClick={handleFormOpen}
                            >
                                Add Portfolio
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} lg={8} sx={{ display: 'flex', justifyContent: 'flex-start', pb: 10 }}>
                        <Grid item>
                            <img src={Promas} alt='Promas' />
                        </Grid>
                        <Typography sx={{ color: "#14142B", fontSize: "14px", p: 1 }}>
                            With more than 30 years experience with property managers and homeowner associations, we are experts in our field providing rock solid accounting software and management tools that help you run your business effectively.
                        </Typography>
                    </Grid>
                    {IntegrationState.apiKey ?
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', pb: 20 }}>
                            <Grid item xs={6} sx={{ borderRadius: '24px', backgroundColor: '#053742', pt: 8, pb: 8 }}>
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Grid item xs={8} pb={4}>
                                        <Typography sx={{ color: "#fff", fontSize: "14px", textAlign: 'center' }}>
                                            Click to reveal the API Key. You will not have access to this key again. Please copy and paste directly into Promas now.
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', }}>
                                    <div>
                                        <InputField
                                            type={showPassword ? "text" : "password"}
                                            defaultValue={IntegrationState.apiKey}
                                            onClick={handleClickShowPassword}
                                            isfullWidth={false}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <CopyToClipboard text={IntegrationState.apiKey}>
                                                        <IconButton
                                                        >
                                                            <ContentCopyIcon onClick={() => { setSnackBarOpen(true) }} />
                                                        </IconButton>
                                                    </CopyToClipboard>
                                                </InputAdornment>
                                            }
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                        :
                        IntegrationState.existingPortfolios.length > 0 ?
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', pb: 20 }}>
                                <Grid item xs={6} sx={{ borderRadius: '24px', backgroundColor: '#053742', p: 8 }}>
                                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <Typography sx={{ color: "#fff", fontSize: "14px", textAlign: 'center' }}>
                                            Changing the API Key for this Promas Database will impact your integration.
                                            Do not use this button to add a new Promas database.
                                            If you need assistance please contact support before proceeding.
                                            In order to change the API Key click on one of the portfolios above.
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <Button className={selectedPortfolioName ? classes.btnStyle : classes.btnStyleDisabled} sx={{ textTransform: 'none' }} disabled={!selectedPortfolioName || IntegrationState.isSending} onClick={handleConfirmationOpen}>
                                            Update API Key
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            : IntegrationState.isSending ? null :
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', pb: 20 }}>
                                    <Grid item xs={6} sx={{ borderRadius: '24px', backgroundColor: '#053742', pt: 8, pb: 8 }}>
                                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <Typography sx={{ color: "#fff", fontSize: "14px" }}>
                                                Click the button below to Add a Promas Database to your Inosio Account
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <Button className={classes.btnStyle} sx={{ textTransform: 'none' }} onClick={handleFormOpen}>
                                                Add Integration
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                    }
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', pb: 10 }}>
                        <img width={'95%'} src={PromasProcess} alt="PromasProcess" />
                    </Grid>
                </Grid>
                <Modal
                    open={formOpen}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Grid item xs={12} sx={{ display: 'flex', marginTop: '2%' }}>
                            <Grid item xs={8.3} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginLeft: '30%' }}>
                                <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: '700' }}>
                                    Add/Edit a Portfolio
                                </Typography>
                            </Grid>
                            <Grid item pr={2} xs={3.7} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginLeft: '20%' }}>
                                <IconButton sx={{ color: '#39A2DB' }} onClick={() => {
                                    setFormPortfolioName('')
                                    setFormOpen(false)
                                }}>
                                    <CancelIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} p={2} sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Typography id="modal-modal-description" sx={{ mt: 2, fontWeight: '700', mb: 2 }}>
                                    Create your portfolio
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', '.MuiInputBase-input-MuiOutlinedInput-input': {padding: '15px 10px !important'}}}>
                                <div>
                                    <TextField
                                        label='Portfolio Name'
                                        InputProps={
                                            {inputProps: {min: 0, style: { textAlign: 'left' }}}
                                        }
                                        value={formPortfolioName}
                                        onChange={(e) => { setFormPortfolioName(e.currentTarget.value) }}
                                        fullWidth={false}
                                        sx={{
                                            width: '340px', 
                                            [`& fieldset`]: {
                                                borderRadius: '24px'
                                            },
                                        }}
                                    />
                                </div>
                            </Grid>
                            <Grid item pb={8} pt={4} sx={{ display: 'flex', justifyContent: 'center', }}>
                                <img src={PTI} alt='PTI' />
                            </Grid>
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button className={formPortfolioName ? IntegrationState.isSending ? classes.btnStyleDisabled : classes.btnStyle : classes.btnStyleDisabled} sx={{ textTransform: 'none' }} disabled={!formPortfolioName || IntegrationState.isSending} onClick={onCreate}>
                                    create
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Modal>
                <Modal
                    open={openConfirmation}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Grid sx={{display:'flex', justifyContent:'center'}}>
                            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: '700' }}>
                                Warning!
                            </Typography>
                        </Grid>
                        <Box p={2} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Typography id="modal-modal-description" sx={{ mt: 2, mb: 2, textAlign: 'center' }}>
                                {`You are making changes to ${selectedPortfolioName}`}
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2, mb: 2, textAlign: 'center' }}>
                                Updating your API key will break your existing integration until the key has been changed in Promas. You need to do this immediately.
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2, mb: 2, textAlign: 'center' }}>
                                Are you sure you want to proceed ?
                            </Typography>
                            <Grid item>
                                <Button className={classes.btnStyleLight} sx={{ textTransform: 'none' }} onClick={handleUpdateApiKey}>
                                    Yes
                                </Button>
                                <Button className={classes.btnStyle} sx={{ textTransform: 'none' }} onClick={() => { setOpenConfirmation(false) }}>
                                    No
                                </Button>
                            </Grid>

                        </Box>

                    </Box>
                </Modal>
                <Snackbar anchorOrigin={{ horizontal: 'center', vertical: 'top' }} open={snackBarOpen} autoHideDuration={4000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        Copied to Clipboard
                    </Alert>
                </Snackbar>
            </Card>
        </Grid>
    )
}
